// After a mutate-then-refetch (refreshData() re-requesting the SAME
// pageIndex), decide whether the refetch landed on a now-empty non-first
// page -- e.g. the completed/updated action was the last row on that page --
// so the caller can step back one page and refetch once.
export function shouldStepBackPage(
  refetchedData: any[] | undefined,
  pageIndex: number,
): boolean {
  return (refetchedData?.length ?? 0) === 0 && pageIndex > 0;
}
